import jwt_decode from "jwt-decode";
import { refreshAccessToken } from "./apiFunctions";
import { COOKIE_OPTIONS_SUFFIX, COOKIE_CLEAR_SUFFIX } from "./cookieConfig";
import { Capacitor } from "@capacitor/core";
import router from "@/router";
import { config } from "@/config";
import store from "../store";
import EventBus from "./EventBus";
// import store from "../store";

const checkToken = async () => {
  var payload = { email: "", jwttoken: "" };
  var cookieToken = await localStorage.vue_token;
  if (cookieToken == null || cookieToken == "") {
    // store.commit("userVUEX/checkLoginStatus", false);
    return false;
  } else {
    var decoded = jwt_decode(cookieToken);
    payload.email = decoded.email;
    payload.jwttoken = decoded.sub;
    // store.commit("userVUEX/saveUserData", payload);
    // store.dispatch("userVUEX/getUserData");
    //store.dispatch("saveUserData", payload);
    // store.commit("userVUEX/checkLoginStatus", true);
    let currentTime = Math.floor((new Date()).getTime())
    if (currentTime >= decoded.exp * 1000) {
      return false;
    } else {
      return true;
    }
  }
};
export default checkToken;

export const checkTokenExpiry = () => {
  // let cookieToken = localStorage.getItem("vue_token");
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  let currentTime = Math.floor((new Date()).getTime())
  if (currentTime >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};

export const startTokenExpiryWatcher = () => {
  setInterval(async () => {
    if (checkBeforeTokenExpiry()) {
      // Token is expiring within the next 5 minutes
      // Refresh the token based on login type
      await refreshAccessToken();
    }
  }, 60000); // Check every 1 minute
};

export const checkBeforeTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Math.floor((new Date()).getTime())
  let timeDifference = expirationTime - currentTime;
  if (timeDifference <= 300000 && timeDifference > 0) {
    return true;
  } else {
    return false;
  }
};

// export const getToken = () => {
//   return localStorage.getItem("vue_token");
// };

export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
  // return localStorage.getItem("vue_token");
};

export const getShowPreference = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
}

export const getLoginType = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        console.log(cur[0])
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
}



export const setShowPreference = (data) => {
  data.showPreference = false;
  console.log(data);
  document.cookie = `loginData=${JSON.stringify(data)}; ${COOKIE_OPTIONS_SUFFIX}`;
};


export const getRefreshToken = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "refreshToken") {
				return cur[1];
			}
		}
	}
	return null;
	// return localStorage.getItem("vue_token");
};

// Remove Token
export const removeToken = () => {
	return localStorage.removeItem("vue_token");
};

// export const setToken = (token) => {
//   const TokenKey = localStorage.setItem("vue_token", token);
//   return TokenKey;
// };

export const setRefreshToken = (token) => {
	document.cookie = `refreshToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
	localStorage.setItem("refresh_token", token);
};

export const setToken = (token) => {
	document.cookie = `accessToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
	localStorage.setItem("vue_token", token);
};

export const setLocalTokens = () => {
	localStorage.setItem("vue_token", getToken());
	localStorage.setItem("refresh_token", getRefreshToken());
	store.commit("userVUEX/SET_TOKEN", getToken());
	store.commit("userVUEX/SET_REFRESH_TOKEN", getRefreshToken());
};

export const clearCookies = () => {
	var cookies = document.cookie.split(";");

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf("=");
		var name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
		if (name != "hire3x_heera_notifications") {
			document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
		}
	}

	const adminState = localStorage.getItem("simpAdminState");
	localStorage.clear();
	if (adminState) {
		localStorage.setItem("simpAdminState", adminState);
	}
};

export const clearAllCookiesExceptGuest = () => {
	var cookies = document.cookie.split(";");

	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i];
		var eqPos = cookie.indexOf("=");
		var name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
		if (name !== "guest_uuid" && name !== "mobileToken" && name !== "hire3x_heera_notifications") {
			document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
		}
	}

	const adminState = localStorage.getItem("simpAdminState");
	localStorage.clear();
	if (adminState) {
		localStorage.setItem("simpAdminState", adminState);
	}
};


export const getAccess = (value) => {
	let data = document.cookie.split(";");
	for (let i in data) {
		let cur = data[i].split("=");
		if (cur[0].trim() === value && cur[1] != "no-access") {
			return cur[1];
		}
	}
	return null;
	// return localStorage.getItem("vue_token");
};

export const hasAccess = () => {
	return store.getters["userVUEX/getCandAccess"];
};

export const checkAndSetAccess = () => {
	let val = getAccess("candidate") && getToken() ? true : false;
	if(!val) store.dispatch("userVUEX/clearAllVuex");
	store.commit("userVUEX/setCandAccess", val);
	setLocalTokens();
};

export const clearStore = () => {
	let loginDataRaw = getAccess("loginData");
	if (loginDataRaw) {
		let loginData = JSON.parse(loginDataRaw);
		if (loginData && loginData.clearStore) {
			store.dispatch("userVUEX/clearAllVuex");
			delete loginData.clearStore;
			document.cookie = `loginData=${JSON.stringify(loginData)}; ${COOKIE_OPTIONS_SUFFIX}`;
		}
	}
};
// Guest UUID management for anonymous search history
export const getGuestUUID = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "guest_uuid") {
				return cur[1];
			}
		}
	}
	return null;
};

export const setGuestUUID = (uuid) => {
	document.cookie = `guest_uuid=${uuid}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const ensureGuestUUID = () => {
	let uuid = getGuestUUID();
	if (!uuid) {
		uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
			(
				c ^
				(crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
			).toString(16)
		);
		setGuestUUID(uuid);
	}
	return uuid;
};

export const clearGuestUUID = () => {
	document.cookie = `guest_uuid=; ${COOKIE_CLEAR_SUFFIX}`;
};

export const openLoginModal = ({ mode = "login", redirectUrl = null } = {}) => {
	EventBus.$emit("open-login-modal", { mode, redirectUrl });
};

export const getMobileToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "mobileToken") {
        return JSON.parse(cur[1]).token;
      }
    }
  }
  return null;
};

export const logoutRedirect = () => {
  if (Capacitor.isNativePlatform())
    router.push({ name: "Login" });
  else
    window.location.replace(config.websiteBase);
};


export const notGoogleLogin = () => {
	return (!getLoginType() ||( getLoginType() && !getLoginType()?.logged_in || getLoginType()?.logged_in != 'google'));
}
